export enum NOTIFICATION_TYPES_ENUM {
  FINANCING_PENDING = 'financing-pending',
  FINANCING_APPROVED = 'financing-approved',
  FINANCING_PRE_APPROVED = 'financing-pre-approved',
  FINANCING_CUSTOMER_REQUEST = 'financing-customer-request',
  SOLLEADS = 'solleads',
  ORDER = 'order',
}
